type Option = {
    label: string
    id: string
}

export const countries: Option[] = [
    { id: 'United Kingdom', label: 'United Kingdom' },
    { id: 'Austria', label: 'Austria' },
    { id: 'Belgium', label: 'Belgium' },
    { id: 'Bulgaria', label: 'Bulgaria' },
    { id: 'Croatia', label: 'Croatia' },
    { id: 'Cyprus', label: 'Cyprus' },
    { id: 'Czech Republic', label: 'Czech Republic' },
    { id: 'Denmark', label: 'Denmark' },
    { id: 'Estonia', label: 'Estonia' },
    { id: 'Finland', label: 'Finland' },
    { id: 'France', label: 'France' },
    { id: 'Germany', label: 'Germany' },
    { id: 'Greece', label: 'Greece' },
    { id: 'Hungary', label: 'Hungary' },
    { id: 'Ireland', label: 'Ireland' },
    { id: 'Italy', label: 'Italy' },
    { id: 'Latvia', label: 'Latvia' },
    { id: 'Lithuania', label: 'Lithuania' },
    { id: 'Luxembourg', label: 'Luxembourg' },
    { id: 'Malta', label: 'Malta' },
    { id: 'Netherlands', label: 'Netherlands' },
    { id: 'Poland', label: 'Poland' },
    { id: 'Portugal', label: 'Portugal' },
    { id: 'Romania', label: 'Romania' },
    { id: 'Slovakia', label: 'Slovakia' },
    { id: 'Slovenia', label: 'Slovenia' },
    { id: 'Spain', label: 'Spain' },
    { id: 'Sweden', label: 'Sweden' }
].sort((a, b) => (a.id > b.id ? 1 : -1))

export const foreignCities: Option[] = [
    {
        label: 'Brussels (Belgium)',
        id: 'Brussels (Belgium)'
    },
    {
        label: 'Uzhorod (Ukraine)',
        id: 'Uzhorod (Ukraine)'
    },
    {
        label: 'Asola (Italy)',
        id: 'Asola (Italy)'
    },
    {
        label: 'Alicante (Spain)',
        id: 'Alicante (Spain)'
    },
    {
        label: 'Prague (Czech Republic)',
        id: 'Prague (Czech Republic)'
    },
    {
        label: 'Wien (Austria)',
        id: 'Wien (Austria)'
    },
    {
        label: 'Warwick (UK)',
        id: 'Warwick (UK)'
    }
].sort((a, b) => (a.id > b.id ? 1 : -1))

export const slovakCities: Option[] = [
    {
        label: 'Bratislava',
        id: 'Bratislava'
    },
    {
        label: 'Senec',
        id: 'Senec'
    },
    {
        label: 'Malacky',
        id: 'Malacky'
    },
    {
        label: 'Pezinok',
        id: 'Pezinok'
    },
    {
        label: 'Trnava',
        id: 'Trnava'
    },
    {
        label: 'Dunajská Streda',
        id: 'Dunajská Streda'
    },
    {
        label: 'Galanta',
        id: 'Galanta'
    },
    {
        label: 'Piešťany',
        id: 'Piešťany'
    },
    {
        label: 'Hlohovec',
        id: 'Hlohovec'
    },
    {
        label: 'Senica',
        id: 'Senica'
    },
    {
        label: 'Skalica',
        id: 'Skalica'
    },
    {
        label: 'Trenčín',
        id: 'Trenčín'
    },
    {
        label: 'Nové Mesto nad Váhom',
        id: 'Nové Mesto nad Váhom'
    },
    {
        label: 'Iľava',
        id: 'Iľava'
    },
    {
        label: 'Prievidza',
        id: 'Prievidza'
    },
    {
        label: 'Považská Bystrica',
        id: 'Považská Bystrica'
    },
    {
        label: 'Bánovce nad Bebravou',
        id: 'Bánovce nad Bebravou'
    },
    {
        label: 'Púchov',
        id: 'Púchov'
    },
    {
        label: 'Partizánske',
        id: 'Partizánske'
    },
    {
        label: 'Myjava',
        id: 'Myjava'
    },
    {
        label: 'Nitra',
        id: 'Nitra'
    },
    {
        label: 'Levice',
        id: 'Levice'
    },
    {
        label: 'Nové Zámky',
        id: 'Nové Zámky'
    },
    {
        label: 'Topoľčany',
        id: 'Topoľčany'
    },
    {
        label: 'Komárno',
        id: 'Komárno'
    },
    {
        label: 'Šaľa',
        id: 'Šaľa'
    },
    {
        label: 'Zlaté Moravce',
        id: 'Zlaté Moravce'
    },
    {
        label: 'Žilina',
        id: 'Žilina'
    },
    {
        label: 'Liptovský Mikuláš',
        id: 'Liptovský Mikuláš'
    },
    {
        label: 'Martin',
        id: 'Martin'
    },
    {
        label: 'Kysucké Nové Mesto',
        id: 'Kysucké Nové Mesto'
    },
    {
        label: 'Ružomberok',
        id: 'Ružomberok'
    },
    {
        label: 'Námestovo',
        id: 'Námestovo'
    },
    {
        label: 'Dolný Kubín',
        id: 'Dolný Kubín'
    },
    {
        label: 'Tvrdošín',
        id: 'Tvrdošín'
    },
    {
        label: 'Bytča',
        id: 'Bytča'
    },
    {
        label: 'Čadca',
        id: 'Čadca'
    },
    {
        label: 'Turčianske Teplice',
        id: 'Turčianske Teplice'
    },
    {
        label: 'Košice',
        id: 'Košice'
    },
    {
        label: 'Michalovce',
        id: 'Michalovce'
    },
    {
        label: 'Spišská Nová Ves',
        id: 'Spišská Nová Ves'
    },
    {
        label: 'Trebišov',
        id: 'Trebišov'
    },
    {
        label: 'Rožňava',
        id: 'Rožňava'
    },
    {
        label: 'Gelnica',
        id: 'Gelnica'
    },
    {
        label: 'Sobrance',
        id: 'Sobrance'
    },
    {
        label: 'Banská Bystrica',
        id: 'Banská Bystrica'
    },
    {
        label: 'Zvolen',
        id: 'Zvolen'
    },
    {
        label: 'Žiar nad Hronom',
        id: 'Žiar nad Hronom'
    },
    {
        label: 'Lučenec',
        id: 'Lučenec'
    },
    {
        label: 'Brezno',
        id: 'Brezno'
    },
    {
        label: 'Žarnovica',
        id: 'Žarnovica'
    },
    {
        label: 'Detva',
        id: 'Detva'
    },
    {
        label: 'Rimavská Sobota',
        id: 'Rimavská Sobota'
    },
    {
        label: 'Krupina',
        id: 'Krupina'
    },
    {
        label: 'Veľký Krtíš',
        id: 'Veľký Krtíš'
    },
    {
        label: 'Banská Štiavnica',
        id: 'Banská Štiavnica'
    },
    {
        label: 'Revúca',
        id: 'Revúca'
    },
    {
        label: 'Poltár',
        id: 'Poltár'
    },
    {
        label: 'Prešov',
        id: 'Prešov'
    },
    {
        label: 'Poprad',
        id: 'Poprad'
    },
    {
        label: 'Kežmarok',
        id: 'Kežmarok'
    },
    {
        label: 'Stará Ľubovňa',
        id: 'Stará Ľubovňa'
    },
    {
        label: 'Bardejov',
        id: 'Bardejov'
    },
    {
        label: 'Sabinov',
        id: 'Sabinov'
    },
    {
        label: 'Humenné',
        id: 'Humenné'
    },
    {
        label: 'Levoča',
        id: 'Levoča'
    },
    {
        label: 'Vranov nad Topľou',
        id: 'Vranov nad Topľou'
    },
    {
        label: 'Svidník',
        id: 'Svidník'
    },
    {
        label: 'Snina',
        id: 'Snina'
    },
    {
        label: 'Stropkov',
        id: 'Stropkov'
    },
    {
        label: 'Medzilaborce',
        id: 'Medzilaborce'
    }
].sort((a, b) => (a.id > b.id ? 1 : -1))

export const allLocations = [...slovakCities, ...foreignCities, ...countries]
